import { levelTrackingMap } from "../constants";

export const getLevelTackingValue = (level?:string | null) => {
  if (!level) return;
  if (Object.keys(levelTrackingMap).includes(level.toLowerCase())) {
    return levelTrackingMap[level.toLowerCase() as keyof typeof levelTrackingMap];
  }
};
